import React from 'react'
import { InputText } from 'primereact/inputtext'

export default ({ onChange, value, children = null }) => {
  return (
    <div style={{ textAlign: 'left' }}>
      <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
      <InputText
        style={{ maxWidth: '443px', width: '100%' }}
        type="search"
        name="datatable-global-filter"
        autoComplete="off"
        value={value}
        onChange={e => onChange(e.target.value)}
        // onInput={(e) => onChange(e.target.value)}
        placeholder="Pesquisar . . ."
        size="50"
      />
      {children}
    </div>
  )
}
